/* eslint no-console:0 */
import { client } from 'config/apollo';
import { FRAGMENT_NAME_CASE } from 'Common/constants';

const submitCaseSearch = (options, onSuccess, onFailure) => async (
  dispatch,
  getState
) => {
  const { schemaReducer } = getState();
  const variables = {
    q: options.q,
    size: options.size || 500, // As per TRIL-757, we reduced size 1000 to 500
    from: options.from || 0
  };

  const query = options.fields
    ? options.query(options.fields)
    : options.query(schemaReducer.fragments[FRAGMENT_NAME_CASE]);
  try {
    const { data } = await client.query({
      query,
      variables,
      fetchPolicy: 'network-only'
    });
    console.log('got data', data);
    const cases = Object.isFrozen(data)
      ? JSON.parse(JSON.stringify(data))
      : data;

    dispatch(onSuccess(cases));
  } catch (e) {
    console.error(e);

    dispatch(onFailure([]));
  }
};

export default submitCaseSearch;
